var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-check-container" }, [
    _vm._m(0),
    _c("div", { staticClass: "ai-stats-grid" }, [
      _c("div", { staticClass: "stat-card blue" }, [
        _vm._m(1),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Tổng đối tác ngân hàng"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.dataTable.length)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "stat-card green" }, [
        _vm._m(2),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Đang hỗ trợ kết nối"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.stats.activeCount)),
          ]),
        ]),
      ]),
      _vm._m(3),
    ]),
    _c(
      "div",
      { staticClass: "glass-card table-container" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading.table,
                expression: "loading.table",
              },
            ],
            ref: "multipleTable",
            staticClass: "modern-table",
            attrs: {
              data: _vm.dataTable,
              "element-loading-text": "Đang tải danh sách ngân hàng...",
              "element-loading-spinner": "el-icon-loading",
              "element-loading-background": "rgba(255,255,255,0.7)",
              border: "",
              "highlight-current-row": "",
              "max-height": _vm.tableMaxHeight,
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "STT",
                width: "60",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "Logo", width: "140", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "bank-logo-wrapper" },
                        [
                          _c(
                            "el-image",
                            {
                              staticClass: "bank-logo",
                              attrs: { src: row.logo, fit: "contain" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "image-slot",
                                  attrs: { slot: "error" },
                                  slot: "error",
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-picture-outline",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tên ngân hàng đối tác",
                "min-width": "250",
                prop: "name",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "bank-name" }, [
                        _vm._v(_vm._s(row.name)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tên thương hiệu",
                "min-width": "180",
                align: "center",
                prop: "shortName",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "short-name-badge" }, [
                        _vm._v(_vm._s(row.shortName || "—")),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tên viết tắt",
                "min-width": "180",
                align: "center",
                prop: "short_name",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "span",
                        { staticClass: "short-name-badge secondary" },
                        [_vm._v(_vm._s(row.short_name || "—"))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Trạng thái hệ thống",
                width: "200",
                align: "center",
                prop: "delActive",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "status-badge",
                          class: row.delActive ? "online" : "offline",
                        },
                        [
                          _c("span", { staticClass: "dot" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                row.delActive
                                  ? "Hỗ trợ kết nối"
                                  : "Ngừng hỗ trợ"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _c("div", { staticClass: "banner-left" }, [
          _c("div", { staticClass: "ai-icon-pulse" }, [
            _c("i", { staticClass: "el-icon-bank" }),
          ]),
          _c("div", [
            _c("h1", { staticClass: "banner-title" }, [
              _vm._v("DANH SÁCH NGÂN HÀNG HỖ TRỢ THANH TOÁN"),
            ]),
            _c("p", { staticClass: "banner-subtitle" }, [
              _vm._v(
                "Xem danh sách các đối tác ngân hàng được hỗ trợ liên kết và thanh toán trực tuyến qua cổng SePay."
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-folder-opened" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-card purple" }, [
      _c("div", { staticClass: "stat-icon" }, [
        _c("i", { staticClass: "el-icon-circle-close" }),
      ]),
      _c("div", { staticClass: "stat-info" }, [
        _c("p", { staticClass: "stat-label" }, [_vm._v("Đã cấu hình")]),
        _c("h3", { staticClass: "stat-value" }, [_vm._v("SePay Gateway")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }